import Vue from 'vue';
/* eslint-disable import/no-extraneous-dependencies */
import '@firebase/polyfill';
import {
  ModalPlugin, FormSelectPlugin, ToastPlugin, FormGroupPlugin,
} from 'bootstrap-vue';

import { i18n } from '@/utils/i18n-setup';
import './registerServiceWorker';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import router from './router';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import store from './store';

import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(ModalPlugin);
Vue.use(FormSelectPlugin);
Vue.use(ToastPlugin);
Vue.use(FormGroupPlugin);
Vue.use(VueMoment, {
  moment,
});

const $vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

export default $vm;
